/**
 * Detect browser fetch/network failures (e.g. DNS blocked by ISP,
 * net::ERR_NAME_NOT_RESOLVED, CORS blocked as Failed to fetch, offline).
 */
export const isNetworkFetchError = (error) => {
  if (!error) return false;

  const message = String(error.message || error || "").toLowerCase();

  if (
    message.includes("failed to fetch") ||
    message.includes("networkerror") ||
    message.includes("network request failed") ||
    message.includes("load failed") ||
    message.includes("err_name_not_resolved") ||
    message.includes("err_connection") ||
    message.includes("err_internet_disconnected") ||
    message.includes("err_network_changed") ||
    message.includes("err_timed_out") ||
    message.includes("net::err_")
  ) {
    return true;
  }

  // Native fetch rejects with TypeError when the request cannot complete
  if (error.name === "TypeError" && message.includes("fetch")) {
    return true;
  }

  return false;
};
